<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col v-if="agent" cols="2" align="start" class="align-content-center">
                <div>
                    <v-img
                        :src="this.$store.getters.getClientImage"
                        class="rounded-circle mx-auto"
                        max-width="40"
                    />
                </div>
            </v-col>
            <v-col cols="10" align="start" class="ml-auto">
                <div
                    class="white--text rounded-xl px-3 py-3 bubble-text"
                    :class="[agent ? 'grey--text text--darken-4 grey lighten-3 float-left' : 'float-right']"
                    :style="`background-color: ${mainColor}`"
                >
                    {{ reply.message.attachment.payload.text }}
                </div>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col align="start" :offset="agent ? 2 : 0">
                <span
                    v-for="(button, index) in reply.message.attachment.payload.buttons"
                    :key="index"
                >
                    <v-btn
                        color="grey lighten-2 black--text"
                        class="mx-1 my-1 rounded-xl text-none"
                        :href="button.type === 'phone_number' ? `tel:${button.payload}` : undefined"
                        @click="button.type === 'phone_number' ? undefined : clickButton(button, button.title)"
                        small
                    >
                        {{ button.title }}
                    </v-btn>
                </span>
            </v-col>
        </v-row>
        <v-scale-transition>
            <iframe
                v-if="scanner.show"
                id="boarding-pass-scanner"
                title="boarding-pass-scanner"
                :src="scanner.url"
                sandbox="allow-scripts allow-same-origin"
                allow="camera"
                width="100%"
                height="100%"
            ></iframe>
        </v-scale-transition>
    </v-container>
</template>

<script>
    export default {
        created() {
            this.WEBHOOK_VALIDATION = /[?]scanId=\w+?&bpWebhookUrl=https?:[/]{2}.+/
        },
        props: {
            agent: {
                type: Boolean,
                default: false
            },
            reply: {
                type: Object,
            },
            mainColor: {
                type: String,
                default: null
            }
        },
        data: () => ({
            selection: null,
            scanner: {
                show: false,
                url: null,
            },
        }),
        methods: {
            clickButton(button, buttonText) {
                if (button.url) {
                    if (this.WEBHOOK_VALIDATION.test(button.url)) {
                        this.displayScanner(button.url)
                        return
                    }
                    window.open(button.url, '_blank', 'noreferrer');
                } else {
                    this.$emit('prepareMessage', {
                        text: button.payload,
                        freshchatAgentText: buttonText
                    })
                }
            },
            displayScanner(url) {
                this.scanner = {
                    show: true,
                    url
                }
                const onScannerMessage = async (event) => {
                    switch (event.data?.scanner) {
                        case 'success':
                            await this.sleep(1000)
                            // eslint-disable no-fallthrough
                        case 'canceled':
                            this.scanner.show = false
                            window.removeEventListener('message', onScannerMessage)
                    }
                }
                window.addEventListener('message', onScannerMessage)
            },
            sleep(ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
            }
        }
    }
</script>

<style scoped>
    .v-slide-group__next, .v-slide-group__prev {
        min-width: 0!important;
    }

    a {
        text-decoration: none!important;
        color: unset!important;
    }

    :deep(#boarding-pass-scanner) {
        border: none;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 5;
    }
</style>